module.exports = __webpack_public_path__ + "static/media/logo.124ff3ad.png";